import React, { Component } from "react";

class ReCaptcha extends Component {
  componentDidMount() {
    if (this.isReady()) {
      this.renderCaptcha();
      return;
    }
    if (window.recaptchaPromise) {
      window.recaptchaPromise.then(() => {
        this.renderCaptcha();
        window.recaptchaPromise = null;
      });
    }
  }

  renderCaptcha = () => {
    const { sitekey, verifyCallback, expiredCallback } = this.props;
    window.grecaptcha.render("google-recpatcha-container", {
      sitekey: sitekey,
      callback: verifyCallback,
      "expired-callback": expiredCallback,
    });
  };

  isReady = () => {
    return (
      typeof window !== "undefined" &&
      typeof window.grecaptcha !== "undefined" &&
      typeof window.grecaptcha.render === "function"
    );
  };

  render() {
    return <div id="google-recpatcha-container" />;
  }
}

export default ReCaptcha;
